import * as React from 'react';
import { ArticleParagraph1, Responsive, UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import { ESortType } from '../../../types/sort';
import * as style from './style.css';

export interface IReviewSortItemProps {
  type: ESortType;
  title: string;
  isSelected: boolean;
  onClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReviewSortItem: React.FC<IReviewSortItemProps> = ({ type, title, isSelected, onClick }) => {
  return (
    <label htmlFor={title} className={style['label']}>
      <input type="radio" name="reviews-sort" id={title} value={type} onChange={onClick} />

      <div className={style['title']}>
        <Responsive desktop>
          <UIText2 color="text-primary-default">{title}</UIText2>
        </Responsive>

        <Responsive phone tablet>
          <ArticleParagraph1 color="text-primary-default">{title}</ArticleParagraph1>
        </Responsive>

        {isSelected && <IconFunctionalSuccess16 color="icon-main-default" />}
      </div>
    </label>
  );
};
